/**
 * @fileoverview A function that provides a base query for axios.
 *
 * @example
 * const query = axiosBaseQuery()
 */

import { BaseQueryFn } from '@reduxjs/toolkit/dist/query'
import { AxiosError, AxiosRequestConfig } from 'axios'
import { api } from '../../api'

/**
 * @function axiosBaseQuery
 * @description Provides a base query for axios.
 * @param {Object} options - The options for the base query.
 * @returns {BaseQueryFn} - The base query.
 */
export const axiosBaseQuery =
    (
        { baseUrl }: { baseUrl: string } = { baseUrl: '' }
    ): BaseQueryFn<
        {
            url: string
            method: AxiosRequestConfig['method']
            data?: AxiosRequestConfig['data']
            headers?: AxiosRequestConfig['headers']
            params?: AxiosRequestConfig['params']
        },
        unknown,
        unknown
    > =>
    async ({ url, method, data, headers, params }) => {
        try {
            const result = await api({ url: baseUrl + url, headers, method, data, params })
            return { data: result.data }
        } catch (axiosError) {
            const err = axiosError as AxiosError
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            }
        }
    }
